import { render, staticRenderFns } from "./img_sztpklist.vue?vue&type=template&id=1f2da838"
import script from "./img_sztpklist.vue?vue&type=script&lang=js"
export * from "./img_sztpklist.vue?vue&type=script&lang=js"
import style0 from "./img_sztpklist.vue?vue&type=style&index=0&id=1f2da838&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports